<template>
    <v-container>
        <v-row>
            <v-col>
                <v-toolbar flat>
                    <v-toolbar-title>{{ game.title }}</v-toolbar-title>

                    <v-spacer/>

                    <game-menu :game="game"/>
                </v-toolbar>

                <v-card flat tile min-height="500px">
                    <v-card-text>
                        <v-row>
                            <template v-for="(investigator, investigatorIndex) in game.available_investigators">
                                <v-col :key="'graveyard' + investigatorIndex"
                                       cols="12"
                                       sm="6"
                                       md="4">
                                    <investigator :investigator="investigator"
                                                  @chooseInvestigator="chooseInvestigator"/>
                                </v-col>
                            </template>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
  import GameMenu from "./GameMenu";
  import Investigator from "./Investigator";

  export default {
    components: {
      GameMenu,
      Investigator
    },

    computed: {
      game() {
        return this.$store.getters.game;
      }
    },

    methods: {
      chooseInvestigator(investigator) {
        this.$router.push({
          name: "game-preferences",
          params: {gameId: this.$store.getters.game.id, investigatorId: investigator.id}
        });
      }
    }
  };
</script>